import AngularTranslate from 'angular-translate'
import FlatasticConfig from '../../scripts/config'
import PushNotificationsModule from '../../scripts/modules/pushnotification'

export default angular.module('flatastic.intro.notifications.controller', [
  'ionic',
  AngularTranslate,
  FlatasticConfig,
  PushNotificationsModule,
])
.controller('NotificationsController', NotificationsController)
.name;


NotificationsController.$inject = [
  '$rootScope',
  '$state',
  '$timeout',
  'PushNotification',
  '$ionicHistory',
  '$translate',
  'FlatasticEvents',
]
function NotificationsController($rootScope, $state, $timeout, PushNotification, $ionicHistory, $translate, FlatasticEvents) {

  const vm = this;

  vm.enablePushNotifications = enablePushNotifications
  vm.goToMainApp = goToMainApp
  vm.getLanguage = function() { return $translate.proposedLanguage() }

  //// Functions

  function enablePushNotifications() {
    PushNotification.getDeviceTokenAndTellBackend()
      .then(goToMainApp)
      .catch(error => {
        console.error('Error when enabling Push Notifications', error)
        return Promise.reject(error)
      })
  }

  function goToMainApp() {
    $rootScope.$broadcast(FlatasticEvents.user.didEnterWg)
    return $state.go('wg.shouts')
      .then(() => $timeout(750))
      .then($ionicHistory.clearHistory)
  }

}
